// @flow
import React, { type Node } from 'react';

import { Table, Th, Tr, Td } from 'app/common/ui-components/table';
import type { OrderRequestSale } from 'app/common/components/Cafeteria/dataTypes/orderRequestSales/OrderRequestSale.types';

import { useTitles, useColumns } from './columns';
import CellText from '../cells/CellText';
import CellNumber from '../cells/CellNumber';
import CellSellTitle from '../cells/CellSellTitle';

import styles from './ProductListTable.module.scss';;


type Props = {
  items: Array<OrderRequestSale>
}

const ProductListTable = ({ items }: Props): Node => {
  const columns = useColumns();
  const titles = useTitles();

  return (
    <Table className={styles.root}>
      <thead>
        <Tr header className={styles.tableRow}>
          {columns.map((columnId, i) => (
            <Th key={columnId} alignLeft={i === 0}>{titles[i]}</Th>
          ))}
        </Tr>
      </thead>
      <tbody>
        {items.map(({ id, title, cost, amount, total, complexItems }) => (
          <Tr key={id} className={styles.tableRow} hoverHighlighted={false} alignTop>
            <Td><CellSellTitle title={title} items={complexItems} /></Td>
            <Td alignCenter><CellNumber number={cost} /></Td>
            <Td alignCenter><CellText text={amount ? String(amount) : null} /></Td>
            <Td alignCenter><CellNumber number={total} /></Td>
          </Tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ProductListTable;
